// extracted by mini-css-extract-plugin
module.exports = {"main":"DragIcon_main__2FHtr","dots":"DragIcon_dots__YABV2"};